/*
 * @Author: your name
 * @Date: 2021-04-01 10:08:43
 * @LastEditTime: 2021-06-23 17:13:11
 * @LastEditors: wei ze min
 * @Description: In User Settings Edit
 * @FilePath: \uni-xmyxd:\gongzuo\xmh1\xingmahui_front\src\minxs\shareHome.js
 */
export const shareHome={
  created () {
    var shareDataParams = {
      shareLink: this.$http.hostName + "/home",
      shareDesc: "1000万中国家庭都在看！科学育儿，全程陪伴，源于母爱。",
      shareTitle: "星妈会",
      imgUrl: "https://image-mom.feihe.com/wxshare/home.png", //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
  },
}